// LP-local replacement for base/thirdParty/bootstrap.
//
// LPE-10054: the SFRA base barrel requires bootstrap/js/src/carousel.js, which shipped the
// carousel module (and its global [data-ride="carousel"] / [data-slide] data-api) into every
// LP bundle even though LP's carousels are all Swiper-driven. The base barrel is shared with
// app_custom_jw, which does still use the Bootstrap carousel, so it must stay as-is — LP
// requires this file instead.
//
// Keep this list in sync with base/thirdParty/bootstrap.js when SFRA is upgraded.
require('bootstrap/js/src/util.js');
require('bootstrap/js/src/alert.js');
// require('bootstrap/js/src/button.js');
// carousel.js intentionally omitted — see LPE-10054
require('bootstrap/js/src/collapse.js');
// require('bootstrap/js/src/dropdown.js');
require('bootstrap/js/src/modal.js');
require('bootstrap/js/src/scrollspy.js');
require('bootstrap/js/src/tab.js');
// require('bootstrap/js/src/tooltip.js');
// require('bootstrap/js/src/popover.js');
